"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseError_1 = require("./BaseError");
var TransportError = /** @class */ (function (_super) {
    __extends(TransportError, _super);
    function TransportError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this error is regarded as a recoverable error
     * @returns {boolean}
     */
    TransportError.prototype.isRecoverable = function () {
        return false;
    };
    /**
     * Gets the message for this error if possible
     * @returns {string}
     */
    TransportError.prototype.getMessage = function () {
        if (this.error.hasOwnProperty("response") &&
            this.error.response.hasOwnProperty("message")) {
            return this.error.response.message;
        }
        return _super.prototype.getMessage.call(this);
    };
    /**
     * Gets the status code attributed with this error
     */
    TransportError.prototype.getStatusCode = function () {
        if (this.error.hasOwnProperty("response") &&
            this.error.response.hasOwnProperty("status")) {
            return this.error.response.status;
        }
        return "503";
    };
    return TransportError;
}(BaseError_1.BaseError));
exports.TransportError = TransportError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhbnNwb3J0RXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvQVBJL1NpbXBsZUFQSS9FcnJvcnMvVHJhbnNwb3J0RXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUEseUNBQXdDO0FBRXhDO0lBQW9DLGtDQUFTO0lBQTdDOztJQW1DQSxDQUFDO0lBbENDOzs7T0FHRztJQUNJLHNDQUFhLEdBQXBCO1FBQ0UsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksbUNBQVUsR0FBakI7UUFDRSxJQUNFLElBQUksQ0FBQyxLQUFLLENBQUMsY0FBYyxDQUFDLFVBQVUsQ0FBQztZQUNyQyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxjQUFjLENBQUMsU0FBUyxDQUFDLEVBQzdDO1lBQ0EsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUM7U0FDcEM7UUFDRCxPQUFPLGlCQUFNLFVBQVUsV0FBRSxDQUFDO0lBQzVCLENBQUM7SUFFRDs7T0FFRztJQUNJLHNDQUFhLEdBQXBCO1FBQ0UsSUFDRSxJQUFJLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxVQUFVLENBQUM7WUFDckMsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsY0FBYyxDQUFDLFFBQVEsQ0FBQyxFQUM1QztZQUNBLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDO1NBQ25DO1FBQ0QsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0lBQ0gscUJBQUM7QUFBRCxDQUFDLEFBbkNELENBQW9DLHFCQUFTLEdBbUM1QztBQW5DWSx3Q0FBYyJ9